module.exports = __webpack_public_path__ + "img/NL9361066.ae2d555a.png";